import { updateDb } from "../services/updateDb";

// Dental practices that signed up through the KNMT (not the KNMT super environment itself).
export const isKnmtPractice = (user) => !!user && user.parentEnvironment === "knmt" && user.environmentId !== "knmt";

const STANDARD_LABELS = { NEN7510: "NEN 7510", ISO27001: "ISO 27001" };
export const formatStandard = (standard) => STANDARD_LABELS[standard] || standard || "ISO 27001";

// Template risks are written as "<nr> - <title> - <description>"; fall back to the full text.
export const splitTemplateRisk = (description = "") => {
  const text = description.trim().replace(/^\d+\s*-\s+/, "");
  const separator = text.indexOf(" - ");
  if (separator === -1) return { title: text, body: "" };
  return { title: text.slice(0, separator).trim(), body: text.slice(separator + 3).trim() };
};

// Mirror the flag in the client session (state + stored user) so a reload doesn't reopen the tour.
export const rememberOnboardingLocally = (setCurrentUser) => {
  setCurrentUser((user) => (user ? { ...user, onboardingCompleted: true } : user));
  try {
    const stored = JSON.parse(localStorage.getItem("user"));
    if (stored) localStorage.setItem("user", JSON.stringify({ ...stored, onboardingCompleted: true }));
  } catch (e) {
    // localStorage might be unavailable
  }
};

// Persist that the user finished or skipped the welcome tour so it doesn't return on later logins.
export const markOnboardingCompleted = (setCurrentUser) => {
  rememberOnboardingLocally(setCurrentUser);
  return updateDb("/api/users/onboarding/complete", {});
};
